/**
 * Returns url without parameters/
 * @param {Object} location - window.location
 * @returns {String} Url string
 */
export const getUrl = location => `${location.protocol}//${location.host}${location.pathname}`;
